/* requires:
polyfill.js
*/

const categoryArray = [
  'Alabama',
  'Arizona',
  'Arkansas',
  'California',
  'Colorado',
  'Connecticut',
  'Delaware',
  'District of Columbia',
  'Georgia',
  'Hawaii',
  'Idaho',
  'Illinois',
  'Indiana',
  'Iowa',
  'Kansas',
  'Kentucky',
  'Louisiana',
  'Maine',
  'Maryland',
  'Massachusetts',
  'Michigan',
  'Minnesota',
  'Mississippi',
  'Missouri',
  'Montana',
  'New Jersey',
  'New York',
  'Nebraska',
  'Nevada',
  'New Mexico',
  'New Hampshire',
  'North Dakota',
  'Ohio',
  'Oklahoma',
  'Oregon',
  'Pennsylvania',
  'Rhode Island',
  'South Carolina',
  'South Dakota',
  'Tennessee',
  'Texas',
  'Vermont',
  'Virginia',
  'Wisconsin',
  'Wyoming',
];

const addProductForm = {
  init: function (formId) {
    const modalElement = document.getElementById('addProductModal');
    // Store modal instance on the element itself to prevent recreation
    if (!modalElement.bootstrapModal) {
      modalElement.bootstrapModal = new bootstrap.Modal(modalElement);
    }
    const categorySelect = document.getElementById('select-course-category');
    const courseSelect = document.getElementById('select-course');
    const theForm = document.getElementById(formId);

    let currentCategory;

    // Reset form state on both init and modal show
    const resetFormState = () => {
      if (currentCategory !== undefined) {
        addProductForm.populateProducts(currentCategory, courseSelect);
      } else {
        const existingMessage = courseSelect.nextElementSibling;
        if (existingMessage && existingMessage.classList.contains('text-danger')) {
          existingMessage.remove();
        }
        this.populateCategories(courseSelect, categorySelect);
        courseSelect.disabled = true;
        courseSelect.innerHTML = `<option value="" selected="selected" disabled>${
          spanishFlag == true ? 'Seleccionar curso' : 'Select Course' //checks for spanish flag
        }</option>`;
      }
    };

    // Add modal event listener only once
    if (!modalElement.hasResetListener) {
      modalElement.addEventListener('show.bs.modal', resetFormState);
      modalElement.hasResetListener = true;
    }

    this.validateOnBlur(theForm);
    this.populateCategories(courseSelect, categorySelect);

    // listening for click on the submit button
    const submitBtn = theForm.querySelector('button[type="submit"]');
    const bulkBox = document.getElementById('bulk-box');

    // remove the event listener so we can add it back when the form is re-rendered
    const handleSubmit = (event) => {
      event.preventDefault();
      const isFormValid = addProductForm.isFormValid(theForm);
      if (!isFormValid) {
        alert(spanishFlag ? 'Por favor selecciona tu estado y curso.' : 'Please select your state and course.');
      } else {
        bulkBox.classList.add('processing');
        // Ensure we're using the stored modal instance
        modalElement.bootstrapModal.hide();
        // Get the data-id attribute value of the selected option
        const selectedCourseID = courseSelect.options[courseSelect.selectedIndex].getAttribute('value');
        currentCategory = categorySelect.value;
        cart.addToCart({ productId: selectedCourseID, quantity: 1 }, false, false, () => {
          bulkOrder.init();
          // Get fresh data after cart update
          addProductForm.populateProducts(currentCategory, courseSelect);
          const waitForProcessing = setInterval(() => {
            if (!bulkBox.classList.contains('processing')) {
              clearInterval(waitForProcessing);
              const quantityInput = document.querySelector(`input[name="${selectedCourseID}"]`);
              quantityInput.focus();
            }
          }, 100);
        });
      }
    };
    if (!submitBtn.handleSubmit) {
      submitBtn.handleSubmit = handleSubmit;
      submitBtn.addEventListener('click', submitBtn.handleSubmit);
    }
  },

  populateCategories: function (courseSelect, categorySelect) {
    let categoryOptions = `<option value="" selected="selected" disabled="disabled">${
      spanishFlag == true ? 'Seleccionar estado' : 'Select State' //check for spanish flag
    }</option>`;

    // Iterate through the categoryArray to create options
    for (let category of categoryArray) {
      categoryOptions += `<option value="${category}">${category}</option>`;
    }

    categorySelect.innerHTML = categoryOptions;

    categorySelect.addEventListener('change', function () {
      courseSelect.disabled = false;
      addProductForm.populateProducts(this.value, courseSelect);
    });
  },

  populateProducts: function (selectedCategory, courseSelect) {
    const storedProducts = sessionStorage.getItem('productsData');
    const localCart = cart.getLocalCart();
    const localCartProducts = localCart.cartProducts;

    let courseOptions = `<option value="" selected="selected" disabled="disabled">${
      spanishFlag == true ? 'Seleccionar curso' : 'Select Course' //checks for spanish flag
    }</option>`;

    if (storedProducts) {
      const parsedProducts = JSON.parse(storedProducts);
      const stateSpecificCourses = parsedProducts
        .filter((product) => product.tags.includes(selectedCategory) && !product.tags.includes('MK-HideOnBulkPage'))
        .sort((a, b) => {
          return a.name.localeCompare(b.name, undefined, {
            numeric: true,
            sensitivity: 'base',
          });
        });
      const generalCourses = parsedProducts
        .filter((product) => product.tags.includes('All States'))
        .sort((a, b) => {
          return a.name.localeCompare(b.name, undefined, {
            numeric: true,
            sensitivity: 'base',
          });
        });

      const createOptionElements = (products, localCartProducts) => {
        return products
          .map((product) => {
            const isInCart = localCartProducts.some((localProduct) => localProduct.productId === product.id);
            return `<option value="${product.id}" ${isInCart ? 'disabled' : ''}>${product.name}${
              isInCart ? (spanishFlag ? ' (En carro)' : ' (In Cart)') : ''
            }</option>`;
          })
          .join('');
      };

      const areAllProductsInCart = (products, localCartProducts) => {
        return products.every((product) => localCartProducts.some((cartProduct) => cartProduct.productId === product.id));
      };

      courseOptions += createOptionElements(stateSpecificCourses, localCartProducts);

      // Remove any existing messages
      const existingMessage = courseSelect.nextElementSibling;
      if (existingMessage && existingMessage.classList.contains('text-danger')) {
        existingMessage.remove();
      }

      // Add messages if all products are in cart
      const allStateCoursesInCart = areAllProductsInCart(stateSpecificCourses, localCartProducts);
      const allGeneralCoursesInCart = areAllProductsInCart(generalCourses, localCartProducts);

      if (allStateCoursesInCart && allGeneralCoursesInCart) {
        courseSelect.insertAdjacentHTML(
          'afterend',
          `<div class="text-danger mt-2 small text-center">${
            spanishFlag
              ? 'Todos los cursos para este estado ya están en el carro. Seleccione un estado diferente.'
              : 'All courses for this state are already in the cart. Please select a different state.'
          }</div>`
        );
      }
    }

    courseSelect.innerHTML = courseOptions;
  },

  validateOnBlur: function (theForm) {
    if (!theForm) return false;

    // realtime form fields validation using blur event
    const fields = theForm.querySelectorAll('.required');
    for (let field of fields) {
      field.addEventListener(
        'blur',
        function (e) {
          const x = field.value;
          if (!x || x.trim() == '') {
            field.classList.add('is-invalid');
          } else {
            field.classList.remove('is-invalid');
          }
        },
        true
      );
    }
  },

  isFormValid: function (theForm) {
    if (!theForm) return false;

    // form fields validation during submission
    const fields = theForm.querySelectorAll('.required');
    let isFormValid = true;
    for (let field of fields) {
      const x = field.value;
      if (!x || x.trim() == '') {
        field.classList.add('is-invalid');
        isFormValid = false;
      } else {
        field.classList.remove('is-invalid');
      }
    }
    return isFormValid;
  },
};

addProductForm.init('add-product-form');
